<script lang="ts" setup>
import { onMounted, reactive } from "vue";
import { useRoute, useRouter } from "vue-router";

import BreadCrumb from "../../components/Common/BreadCrumb.vue";
import Notificacao from "@/components/Notificacao/Index.vue";
import DropdownVendedores from "@/components/Dropdowns/DropdownVendedores.vue";
import DropdownClientes from "@/components/Dropdowns/DropdownClientes.vue";

import * as service from "@/services/vouchersService";

const route  = useRoute();
const router = useRouter();

const statusOpcoes = [
  { valor: service.eVoucherStatus.Pendente,  descricao: "Pendente"  },
  { valor: service.eVoucherStatus.Pago,      descricao: "Pago"      },
  { valor: service.eVoucherStatus.Cancelado, descricao: "Cancelado" },
];

const controle = reactive({
  model: {
    voucherId:   0,
    vendedorId:  null,
    indicadorId: null,
    indicadoId:  null,
    valor:       0,
    status:      service.eVoucherStatus.Pendente,
    dataPagamento: null,
    dataCartao:    null,
  } as unknown as service.Voucher,
  notificacao: { exibir: false, mensagem: "", tipo: "success" },
  status: "",
  erro:   "",
});

onMounted(() => {
  if (route.params.id) {
    controle.status = "Carregando...";
    service.obterPorId(Number(route.params.id))
      .then(r => { controle.model = r; controle.status = ""; })
      .catch(e => { controle.erro = e.message || String(e); controle.status = ""; });
  }
});

async function salvar() {
  controle.erro   = "";
  controle.status = "Salvando...";
  try {
    await service.salvar(controle.model);
    controle.status = "";
    controle.notificacao = { exibir: true, mensagem: "Salvo com sucesso!", tipo: "success" };
    setTimeout(() => router.push("/vouchers"), 1200);
  } catch (e: any) {
    controle.status = "";
    controle.erro   = e.message || String(e);
  }
}
</script>

<template>
  <BreadCrumb PageTitle="Vouchers" SubTitle="Cadastro" />

  <Notificacao
    :exibir="controle.notificacao.exibir"
    :mensagem="controle.notificacao.mensagem"
    :tipo="(controle.notificacao.tipo as any)"
    @onFechou="controle.notificacao.exibir = false" />

  <div class="card">
    <div class="card-body">

      <div class="row g-3">

        <div class="col-md-4">
          <label class="form-label">Indicador <small class="text-muted">(quem indicou)</small></label>
          <DropdownClientes v-model="controle.model.indicadorId" />
        </div>

        <div class="col-md-4">
          <label class="form-label">Indicado <small class="text-muted">(novo cliente)</small></label>
          <DropdownClientes v-model="controle.model.indicadoId" />
        </div>

        <div class="col-md-4">
          <label class="form-label">Vendedor</label>
          <DropdownVendedores v-model="controle.model.vendedorId" />
        </div>

        <div class="col-md-3">
          <label class="form-label">Valor (R$)</label>
          <input type="number" step="0.01" min="0"
            class="form-control form-control-sm"
            v-model="controle.model.valor" />
        </div>

        <div class="col-md-3">
          <label class="form-label">Status</label>
          <select class="form-select form-select-sm" v-model="controle.model.status">
            <option v-for="(op, i) in statusOpcoes" :key="i" :value="op.valor">{{ op.descricao }}</option>
          </select>
        </div>

        <div class="col-md-3">
          <label class="form-label">Data de Pagamento</label>
          <input type="date" class="form-control form-control-sm"
            v-model="(controle.model as any).dataPagamento" />
        </div>

        <div class="col-md-3">
          <label class="form-label">Data Cartão</label>
          <input type="date" class="form-control form-control-sm"
            v-model="(controle.model as any).dataCartao" />
        </div>

      </div>

      <div class="text-danger mt-3" v-if="controle.erro">{{ controle.erro }}</div>
      <div class="text-muted  mt-3" v-if="controle.status">{{ controle.status }}</div>

    </div>

    <div class="card-footer">
      <div class="d-flex gap-2 justify-content-end">
        <RouterLink class="btn btn-secondary btn-sm" to="/vouchers">Cancelar</RouterLink>
        <button class="btn btn-primary btn-sm" @click="salvar()">
          <i class="flaticon-check"></i> Salvar
        </button>
      </div>
    </div>
  </div>
</template>
